function OtherContacts() {
    return ( 
        <>
        <section className="other-contacts">
            <div className="container">
                <div className="heading">
                    Or contact us by:
                </div>
                <div className="flex-items">
                    <address className="mail">
                        contact@onlyglance.com
                    </address>
                    <div className="icons">
                        &nbsp;&nbsp;<a href="https://api.whatsapp.com/send?phone=48881023203"><i class="bi bi-whatsapp" style={{color: "#22b622"}}></i></a>
                        &nbsp;
                        <a href="https://www.facebook.com/profile.php?id=61569288851617"><i class="bi bi-facebook" style={{color: "#006bff"}}></i></a>
                    </div>
                </div>
                <p className="legal">
                    By contacting us, you automatically agree to our Terms of Service and Privacy Policy. Your data will not be shared with third parties.
                </p>
            </div>
        </section>
        </>
     );
}

export default OtherContacts;